import React from "react";
// import Slider from "../../components/slider/Slider";
// import YatraHero from "../yatra/YatraHero";
import ClientTestimonials from "../../components/testimonials/ClientTestimonials";
import WeekendTourPreview from "../../components/tours/WeekendTourPreview";
// import PilgrimageCarousel from "../../components/pilgrimage/PilgrimageCarousel";

import PopularTourCarousel from "../../components/carousel/PopularTourCarousel";
// import { nepalDhamTours } from "../../components/carousel/NepalDhamCarouselData";
// import { pilgrimageTours } from "../../components/carousel/PilgrimageCarouselData";

import ContactForm from "../../components/contact/ContactForm";
import HomeFaqs from "../../components/faqs/HomeFaqs";
import BookletSection from "../../components/booklets/BookletSection";
import JyotirlingaMiniCards from "../yatra/JyotirlingaMiniCards";
// import YatraExpertsSection from "../yatra/YatraExpertsSection";
import Herosection from "../../components/hero/Herosection";
import BookingSearch from "../../components/hero/BookingSearch";
import OurExpertise from "../../components/home/OurExpertise";
import OurPartners from "../../components/home/OurPartners";
// import TopBar from "../../components/TopBar";


import InstaMoments from "../../components/home/InstaMoments";


const Home = () => {
  return (
    <>
      {/* <Slider /> */}
      {/* <TopBar/> */}
      <Herosection/>
      <BookingSearch />
      <OurExpertise />
      {/* <JyotirlingaMiniCards /> */}
      <WeekendTourPreview />
      <InstaMoments />
      {/* <YatraExpertsSection /> */}
      <BookletSection />
      <HomeFaqs />
      <ClientTestimonials />
      <OurPartners />

    </>
  );
};

export default Home;
